import styled, { css } from 'styled-components';
import FooterWrapper from '../../../../components/FooterWrapper';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 32px;
  padding-top: 32px;
  font-size: 16px;
  text-align: left;
  line-height: 24px;
`;

export const Title = styled.p`
  ${({ theme }) => css`
    font-family: 'Montserrat-Medium'
    font-weight: ${theme.fontWeight.medium};
    color: ${theme.colors.colorGray500};
  `}
`;

export const SubTitle = styled.p`
  ${({ theme }) => css`
    font-family: 'Montserrat-Regular'
    font-weight: ${theme.fontWeight.regular};
    color: ${theme.colors.colorGray400};
    margin-bottom: 16px;
  `}
`;

export const Footer = styled(FooterWrapper)`
  width: 100%;
  background-color: white;
  height: auto;
  position: absolute;
  bottom: 0;
  padding: 20px 20px 30px 20px;
`;
